import React, {Component} from 'react'

class Gwp extends Component {
  constructor(props) {
    super(props)
    const availableProducts = props.json.products.filter(product => product.available)
    let products = availableProducts.filter(product => props.cart.items.filter(item => item.product_id == product.id).length == 0)
    if(props.json.automatic && availableProducts.length > 0) products = [availableProducts[0]]
    const hasGwp = props.cart.items
      .filter(item => products.map(product => product.id).includes(item.product_id) && !!item.properties['Gift']).length > 0
    this.state = {
      data: props.json,
      cart: props.cart,
      products: products,
      selectedProduct: products[0],
      orderThreshold: parseFloat(props.json.orderThreshold),
      hasGwp: hasGwp,
      automatic: props.json.automatic,
    }
    this.instanceRef = React.createRef()
    console.log('Gwp', this.state)
  }

  getProductImage(product) {
    const image = product.media.filter(medium => medium.src.includes('flatlay')).length > 0 ? product.media.filter(medium => medium.src.includes('flatlay'))[0] : product.media[0]
    return (image ? 
    <img src={image.src.replace('.png?', '.png?width=200').replace('.jpg?', '.jpg?width=200')}
      className='w-full h-full object-cover object-center'
      alt={image.alt}
      loading='lazy'
      width={image.width}
      height={image.height}
    />
    : null)
  }
  addToCart(e) {
    e.preventDefault()
    window.addLineItems((cart) => {
        window.initMiniCart(cart)
        window.openCart()
      }, 
      [{id: e.target.getAttribute('data-variant-id'), quantity: 1, properties: { 'Gift': 'with purchase', '_gift_order_threshold': window.gwpData.orderThreshold }}], 
      e.target
    )
  }

  removeGWP(reload=false) {
    let updates = {}
    this.state.cart.items.forEach(item => {
      if(this.state.data.products.filter(product => product.id == item.product_id).length > 0) updates[item.key] = 0
    })
    if(JSON.stringify(updates) != JSON.stringify({})) {
      window.updateLineItems((cart) => {
          if(reload && location.href.includes('/cart')) location.reload()
          window.initMiniCart(cart)
          window.openCart()
        }, 
        updates,
      )
    } else {
      if(reload && location.href.includes('/cart')) location.reload()
    }
  }

  componentDidMount() {
    const originTotal = this.state.cart.original_total_price - (this.state.hasGwp ? this.state.selectedProduct.variants[0].price : 0)
    if(this.state.automatic) {
      if(originTotal / 100.0 < this.state.orderThreshold) {
        this.removeGWP(true)
      } else {
        if(!this.state.hasGwp && this.state.selectedProduct && !Cookies.get('gwp_remove')) {
          window.addLineItems((cart) => {
              this.setState({ hasGwp: true })
              window.initMiniCart(cart)
              window.openCart()
            }, 
            [{id: this.state.selectedProduct.variants[0].id, quantity: 1, properties: { 'Gift': 'with purchase', '_gift_order_threshold': window.gwpData.orderThreshold }}]
          )
          if(location.href.includes('/cart')) {
            setTimeout(() => {
              location.reload()
            }, 500)
          }
        }
      }
    } else {
      if(originTotal / 100.0 < this.state.orderThreshold) {
        this.removeGWP()
      } else {
        if(this.instanceRef.current && this.instanceRef.current.querySelector('[data-gwp-swiper]')) {
          new Swiper(this.instanceRef.current.querySelector('[data-gwp-swiper]'), {
            speed: 300,
            slidesPerView: 3,
            spaceBetween: 10,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          })
        }
      }
    }
  }

  render() {
    return (
      <>
        {
          !this.state.automatic && this.state.products.length > 0 && 
          (parseFloat(this.state.orderThreshold) < this.state.cart.items_subtotal_price / 100.0) &&
          !this.state.hasGwp &&
          <div className='gwp-component py-4 px-3 lg:px-6 -mx-3 lg:-mx-6' style={{backgroundColor: this.state.data.background}} ref={this.instanceRef}>
            { this.state.data.title && 
              <h3 className='text-center mb-1 font-clearface font-black text-lg text-black leading-5'>
                { this.state.data.title }
              </h3> 
            }
            { this.state.data.description && <div className='text-center mb-2 leading-4 mb-4'>{ this.state.data.description }</div> }
            {
              this.state.products.length > 0 &&
              <>
                {
                  this.state.data.layout == 'Slide' &&
                  <>
                    <div className='relative' data-gwp-swiper>
                      <div className='swiper-wrapper'>
                        {
                          this.state.products.map((product, index) =>
                            <div className={
                              `swiper-slide aspect-square overflow-hidden cursor-pointer transition-transform duration-300 ease-in-out ${product.id == this.state.selectedProduct.id ? '!scale-120' : 'hover:!scale-120'}`
                            } 
                              key={`gwp-${product.id}`}
                              onClick={() => {
                                this.setState({
                                  selectedProduct: product,
                                })
                              }}
                            >
                              {this.getProductImage(product)}
                            </div>
                          )
                        }
                      </div>
                      <div className='swiper-button-prev !text-black !w-5 !h-5 after:!text-[1.25rem] !mt-0 !-translate-y-1/2 !-left-3 !h-full !flex !flex-col !items-center !justify-center !bg-lof-beige !bg-opacity-80 !z-1'></div>
                      <div className='swiper-button-next !text-black !w-5 !h-5 after:!text-[1.25rem] !mt-0 !-translate-y-1/2 !-right-3 !h-full !flex !flex-col !items-center !justify-center !bg-lof-beige !bg-opacity-80 !z-1'></div>
                    </div>
                    {
                      this.state.selectedProduct && <div className='mt-4'>Colour: { this.state.selectedProduct.title.split('-')[1]?.trim() }</div>
                    }
                  </>
                }
                {
                  this.state.data.layout == 'Dropdown' &&
                  <div className='flex justify-between gap-2'>
                    <div className='aspect-square overflow-hidden w-20'>
                      {this.getProductImage(this.state.selectedProduct)}
                    </div>
                    <div className={`w-[calc(100%-5.5rem)]`}>
                      <select value={this.state.selectedProduct.id}
                        className='mb-2'
                        onChange={(e) => {
                          this.setState({
                            selectedProduct: this.state.products.filter(p => p.id == parseInt(e.target.value))[0]
                          })
                        }}
                      >
                        { 
                          this.state.products.map((product, index) => 
                            <option value={product.id} key={`gwp-option-${product.id}`}>
                              { product.title }
                            </option>
                          ) 
                        }
                      </select>
                      <div className='text-xs leading-4'>
                        **Drop down variant select,<br />
                        thumbnail updates on selection.
                      </div>
                    </div>
                  </div>
                }
              </>
            }
            {
              this.state.selectedProduct &&
              <div className='flex justify-center'>
                <button className='!bg-lof-red !inline-flex !items-center !justify-center !text-white font-futura font-bold w-32 !mb-0 mt-4 h-6'
                  data-variant-id={this.state.selectedProduct.variants[0].id}
                  onClick={this.addToCart}
                >
                  Add Your Gift
                </button>
              </div>
            }
          </div>
        }
      </>
    )
  }
}
export default Gwp